import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import Img_bg from '../../../imgs/bg.jpg';
import Layout from '../Layout'


const Index = ({children}:{children: ReactNode}) => {


    return (
        <Layout width={800} style={{
            // backgroundImage: 'url(http://cdnq3.mikecrm.com/images/formTemplate/dfrt0122_WtJQGMWFUUBiavQQxvqpjBS.jpg)',
            backgroundImage: `url(${Img_bg})`,
            backgroundAttachment: 'fixed',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
        }}>
            {children}
        </Layout>
    )
}

export default Index;